var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestTimeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80556 3.59199V5.72111C7.55246 5.72116 6.32706 6.08979 5.28193 6.78111C4.23679 7.47243 3.41808 8.4559 2.92774 9.60907C2.4374 10.7622 2.29709 12.0342 2.52427 13.2665C2.75145 14.4988 3.3361 15.6371 4.20541 16.5396C5.07473 17.4421 6.19031 18.069 7.41326 18.3422C8.6362 18.6154 9.9125 18.5228 11.0832 18.076C12.254 17.6292 13.2674 16.848 13.9974 15.8294C14.7274 14.8109 15.1417 13.6002 15.1887 12.348L15.1929 12.1085H17.322C17.322 14.3672 16.4248 16.5334 14.8276 18.1305C13.2305 19.7277 11.0643 20.625 8.80556 20.625C6.54684 20.625 4.38064 19.7277 2.78349 18.1305C1.18633 16.5334 0.289063 14.3672 0.289062 12.1085C0.289062 7.4936 4.10019 3.59199 8.80556 3.59199ZM19.4512 -0.66626V1.46286L13.7803 7.85023H19.4512V9.97936H10.9347V7.85023L16.6045 1.46286H10.9347V-0.66626H19.4512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestTimeWhite);
export default __webpack_public_path__ + "static/media/rest-time-white.f6cfe4b75fd868fffaa967bd95259c77.svg";
export { ForwardRef as ReactComponent };